module.exports = __webpack_public_path__ + "static/16-acce26c0776cac2f25eca26bbc1b2598.jpeg";